import React from 'react';

import styles from './AdminOnboardingChecklist.module.scss';

import { gettingStartedRightSideBarAtom, miniGettingStartedPopupAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import { ReactComponent as XIcon } from 'assets/img/close.svg';
import CheckMarkIcon from 'elements/CheckMarkIcon/CheckMarkIcon';
import { ReactComponent as CheckIcon } from 'containers/createGroup/check.svg';

interface IAdminOnboardingChecklist {
  groupData: any
};

const AdminOnboardingChecklist: React.FC<IAdminOnboardingChecklist> = ({ groupData }) => {
  const [isOpen, setIsOpen] = useAtom(miniGettingStartedPopupAtom);
  const [hideBtn, setHideBtn] = React.useState<boolean>(false);
  const [, setIsRightSideBarOpen] = useAtom(gettingStartedRightSideBarAtom);


  React.useEffect(() => {
    if (hideBtn) {
      setHideBtn(false);
    }
  }, [])


  return (
    <div className={`${styles.admin_onboarding_checklist} ${isOpen ? styles.isOpenWhite : styles.isNotOpenRight}`}>
      {
        !(
          (window.location.pathname.split("/").length >= 3) &&
          (window.location.pathname.split("/")[1] === 'settings')
        ) &&
        window.location.pathname.split("/")[1] !== "pages-preview" &&
        <button className={`${(isOpen || hideBtn) ? styles.Notopen : styles.admin_onboarding_checklist__button}`} >
          <div onClick={() => setIsOpen(true)} className={styles.icon_text}>
            <div className={styles.check_icon}>
              <CheckIcon />
            </div>
              <span className={styles.admin_onboarding_checklist__button_text}>Getting Started</span>

            </div>
            <button className={styles.smallCloseButton} onClick={() => setHideBtn(true)}><XIcon /></button>
          </button>
      }

      <div className={`${isOpen ? styles.open : styles.Notopen}`}>
        <button className={styles.closeButton} onClick={() => setIsOpen(false)}><XIcon /></button>

        <div className={styles.bannerBig}>
          <div className={styles.banner__right}>
            <p className={styles.banner__right_P}>
              Welcome to GroupApp! <br /> <span>Here is how to get started</span>
            </p>
          </div>
        </div>

        <div className={styles.header}>
          <p className={styles.header__text}>
          Check out our setup guide that walks you through how to set up your community, or schedule an onboarding call with us, where we show you:
          </p>
        </div>
        <div className={styles.modalContent}>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
            How to set up your community for your specific goals.
            </p>
          </div>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
            How to onboard members into your community when launching.
            </p>
          </div>

          <div className={styles.modalContent__item}>
            <CheckMarkIcon themeColor='#27AE60' type='checkbox' />
            <p className={styles.modalContent__text}>
            How to monetize your community launch from day one.
            </p>
          </div>

          <div className={styles.actions}>
            <button
              onClick={() => window.open('https://calendly.com/d/crz3-6fc-q39', '_blank')}
              className={styles.demoButton}>Book Onboarding</button>
            <button
              className={styles.skipButton}
              onClick={() => {
                setIsOpen(false)
                setIsRightSideBarOpen(true)
              }}
            >View Setup Guide</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminOnboardingChecklist;